import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "../assets/logo/logo.svg";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleFeaturesClick = (e) => {
    e.preventDefault();

    if (location.pathname === "/") {
      const featuresSection = document.getElementById("features");
      if (featuresSection) {
        featuresSection.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/");
      setTimeout(() => {
        const featuresSection = document.getElementById("features");
        if (featuresSection) {
          featuresSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
    closeMenu();
  };

  const handleContactClick = (e) => {
    e.preventDefault();

    const smoothScrollToSection = () => {
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };

    if (location.pathname === "/") {
      smoothScrollToSection();
    } else {
      navigate("/");
      setTimeout(() => {
        smoothScrollToSection();
      }, 100);
    }

    closeMenu();
  };

  useEffect(() => {
    if (location.hash === "#features") {
      setTimeout(() => {
        const featuresSection = document.getElementById("features");
        if (featuresSection) {
          featuresSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  useEffect(() => {
    if (location.hash === "#contact") {
      setTimeout(() => {
        const contactSection = document.getElementById("contact");
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  return (
    <nav className="bg-[#f6f6f6] w-full pt-5 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between">
          {/* Logo for Desktop */}
          <div
            className="hidden md:flex items-center"
            style={{ marginLeft: "-60px" }}
          >
            <NavLink to="/" className="flex items-center space-x-2">
              <img src={Logo} alt="Logo" className="h-20 w-72" />
            </NavLink>
          </div>

          {/* Mobile-specific Logo */}
          <div className="md:hidden flex items-center">
            <NavLink to="/" className="flex items-center space-x-2">
              <img src={Logo} alt="Logo" className="h-12 w-auto" />
            </NavLink>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-8">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `px-3 transition-colors font-semibold ${
                  isActive ? "text-[#5c5168]" : "text-[#5c5168]"
                }`
              }
            >
              Home
            </NavLink>
            <button
              onClick={handleFeaturesClick}
              className="px-3 transition-colors font-semibold text-[#5c5168]"
            >
              Products
            </button>
            <NavLink
              to="/pricing"
              className={({ isActive }) =>
                `px-3 transition-colors font-semibold ${
                  isActive ? "text-[#5c5168]" : "text-[#5c5168]"
                }`
              }
            >
              Pricing
            </NavLink>
            <button
              onClick={handleContactClick}
              className="px-3 transition-colors font-semibold text-[#5c5168]"
            >
              Contact
            </button>
            <NavLink
              to="/pricing"
              className={({ isActive }) =>
                `px-4 py-2 rounded-md transition-colors border-2 border-black font-semibold ${
                  isActive
                    ? "bg-[#bde9fb] text-black"
                    : "bg-[#bde9fb] text-black hover:bg-black hover:text-[#bde9fb]"
                }`
              }
            >
              Get Started
            </NavLink>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className="text-gray-700 focus:outline-none"
            >
              {isOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden bg-[#f6f6f6] text-center border-t border-gray-200 transition-all duration-1000 ease-in-out ${
          isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-2 pt-2 pb-3 space-y-1">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `block px-3 py-2 rounded-md font-semibold ${
                isActive ? "bg-gray-50" : "text-[#5c5168]"
              }`
            }
            onClick={closeMenu}
          >
            Home
          </NavLink>
          <button
            onClick={handleFeaturesClick}
            className="block w-full px-3 py-2 text-center rounded-md font-semibold text-[#5c5168]"
          >
            Products
          </button>
          <NavLink
            to="/pricing"
            className={({ isActive }) =>
              `block px-3 py-2 rounded-md font-semibold ${
                isActive ? "bg-gray-50" : "text-[#5c5168]"
              }`
            }
            onClick={closeMenu}
          >
            Pricing
          </NavLink>
          <button
            onClick={handleContactClick}
            className="block w-full px-3 py-2 text-center rounded-md font-semibold text-[#5c5168]"
          >
            Contact
          </button>
          <NavLink
            to="/pricing"
            className={({ isActive }) =>
              `block px-3 py-2 rounded-md border-2 border-black font-semibold ${
                isActive
                  ? "bg-[#bde9fb] text-black"
                  : "bg-[#bde9fb] text-black hover:bg-black hover:text-[#bde9fb]"
              }`
            }
            onClick={closeMenu}
          >
            Get Started
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
